import {
    apiRequest,
    kompetensiList,
    kompetensiActive,
    kompetensiInactive,
    kompetensiDetail,
    kompetensiCreate,
    kompetensiUpdate,
    kompetensiDelete,
    kompetensiOption
} from "../../../../../../services/adapters/master/penialian360Service"

class DataTableRepository {

    fetchOption = async (query) => {
        return await apiRequest("get", kompetensiOption, {
            params: query
        }, true)
    }

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", kompetensiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", kompetensiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", kompetensiActive, {
            body: query
        }, true)
    }

    fetchDetail = async (uuid) => {
        return await apiRequest("get", kompetensiDetail, {
            params: { uuid: uuid }
        }, true)
    }

    fetchCreate = async (data) => {
        return await apiRequest("post", kompetensiCreate, {
            body: data
        }, true)
    }

    fetchUpdate = async (data) => {
        return await apiRequest("post", kompetensiUpdate, {
            body: data
        }, true)
    }

    fetchDelete = async (query) => {
        return await apiRequest("post", kompetensiDelete, {
            body: query
        }, true)
    }
}

export default DataTableRepository
